import { Icon } from '@iconify/react/dist/iconify.js';

interface PaginationArrowsProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  showingFrom: number;
  showingTo: number;
  totalItems: number;
  itemLabel?: string;
  className?: string;
}

export default function PaginationArrows({
  hasPrevious,
  hasNext,
  onPreviousPage,
  onNextPage,
  showingFrom,
  showingTo,
  totalItems,
  itemLabel = 'items',
  className = '',
}: PaginationArrowsProps) {
  if (totalItems <= 0) return null;

  return (
    <div className={`transition-all duration-300 ease-in-out ${className}`}>
      <div className="flex items-center gap-3">
        {hasPrevious && (
          <button
            onClick={onPreviousPage}
            disabled={!hasPrevious}
            className="flex items-center gap-1 text-xs rounded-lg transition-colors text-[#C9BAFE] font-semibold hover:text-[#E0D5FF] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Icon icon={'meteor-icons:angles-left'} fontSize={16} />
            Previous
          </button>
        )}

        {totalItems > 0 && (
          <div className="text-xs text-[#939393]">
            Showing {showingFrom}-{showingTo} of {totalItems} {itemLabel}
          </div>
        )}

        {hasNext && (
          <button
            onClick={onNextPage}
            disabled={!hasNext}
            className="flex items-center gap-1 text-xs transition-colors text-[#C9BAFE] font-bold hover:text-[#E0D5FF] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
            <Icon icon={'meteor-icons:angles-right'} fontSize={16} />
          </button>
        )}
      </div>
    </div>
  );
}
